// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.contact-verification-banner[data-v-3acfbe54] {\n  width: calc(100% - 30px);\n  margin: 15px auto 0;\n}\n.contact-verification-banner__link[data-v-3acfbe54] {\n  margin-left: 10px;\n}\n@media (max-width: 767px) {\n.contact-verification-banner[data-v-3acfbe54] {\n    width: 100%;\n}\n}\n", ""]);
// Exports
module.exports = exports;
